<template lang="pug">
  div.fs-13.color-danger.error-msg(style="height: 13px; width: 100%")
    | {{ error }}

</template>

<script>
export default {
  name: 'ErrorMsg',
  props: {
    error: {type: String, 'default': ''}
  }
}
</script>

<style scoped>

</style>
